import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const MyStorage01Table: GenericTableSchemaInterface = {
  id: "my-storage-01",
  name: "My Storage 01",
  description: "This table contains data regarding how many people engage with content in My Storage (continued).",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Get Lease"
    },
    c04: {
      name: "Manage Insurance"
    },
    c05: {
      name: "Unit Size"
    },
    c06: {
      name: "Multiple Accounts"
    },
    c07: {
      name: "Account Login Issues"
    },
    c08: {
      name: "Account General Management"
    },
    c09: {
      name: "Unit Number"
    },
    c10: {
      name: "Navigate to Account Login"
    },
    c11: {
      name: "Mobile App"
    },
    c12: {
      name: "Account Number"
    }
  }
};
